<template>
    <div>
        <el-form :inline="true">
            <el-form-item label=" 代币币种">
                <coin-select :coinType = "queryCondition.coinType" @value="val => queryCondition.coinType = val"></coin-select>
            </el-form-item>
            <el-form-item label="法币">
                <coin-select :coinType = "queryCondition.currencyCoin" @value="val => queryCondition.currencyCoin = val"></coin-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryAdvertising()">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="opType = 'insert',showEdit = true">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="advertInfo">
            <el-table-column label="代币币种" prop="coinType"></el-table-column>
            <el-table-column label="法币币种" prop="currencyCoin"></el-table-column>
            <el-table-column label="商户等级" prop="merchantLevel"></el-table-column>
            <el-table-column label="单笔下单量">
                <template slot-scope="scope">{{scope.row.singleLimitMin}} - {{scope.row.singleLimitMax}}</template>
            </el-table-column>
            <el-table-column label="单笔下单默认值">
                <template slot-scope="scope">{{scope.row.singleLimitDefaultMin}} - {{scope.row.singleLimitDefaultMax}}</template>
            </el-table-column>
            <el-table-column label="商家所有购买广告总量" prop="allTotalMaxForDirectionB"></el-table-column>
            <el-table-column label="广告总数">
                <template slot-scope="scope">买：{{scope.row.advertisingTotalForB}}，卖：{{scope.row.advertisingTotalForS}}</template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="alterInfo(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="sizeChange"
                       @current-change="pageChange"
                       :current-page="queryCondition.pageNo"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryCondition.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="advertTotal">
        </el-pagination>

        <el-dialog title="OTC广告支持币种配置" :visible.sync= "showEdit" @close="closeDialog">
            <el-form label-width="180px" :model="advertEditInfo" ref="advertEditForm">
                <el-form-item label=" 代币币种">
                    <coin-select :coinType = "advertEditInfo.coinType" @value="val => advertEditInfo.coinType = val"></coin-select>
                </el-form-item>
                <el-form-item label="法币">
                    <coin-select :coinType = "advertEditInfo.currencyCoin" @value="val => advertEditInfo.currencyCoin = val"></coin-select>
                </el-form-item>
                <el-form-item label="商户等级" prop="merchantLevel" :rules="[{ required: true, message: '商户等级不能为空',trigger: 'blur'}]">
                    <el-select v-model="advertEditInfo.merchantLevel">
                        <el-option v-for="item in merchantLevels" :label="item.desc" :key="item.code" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="单笔下单最小" prop="singleLimitMin" :rules="[{ required: true, message: '单笔下单最小不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="advertEditInfo.singleLimitMin"></el-input-number>
                </el-form-item>
                <el-form-item label="单笔下单最大" prop="singleLimitMax" :rules="[{ required: true, message: '单笔下单最大不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="advertEditInfo.singleLimitMax"></el-input-number>
                </el-form-item>
                <el-form-item label="单笔下单最小默认值" prop="singleLimitDefaultMin" :rules="[{ required: true, message: '单笔下单最小默认值不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="advertEditInfo.singleLimitDefaultMin"></el-input-number>
                </el-form-item>
                <el-form-item label="单笔下单最大默认值" prop="singleLimitDefaultMax" :rules="[{ required: true, message: '单笔下单最大默认值不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="advertEditInfo.singleLimitDefaultMax"></el-input-number>
                </el-form-item>
                <el-form-item label="商家所有购买广告总量" prop="allTotalMaxForDirectionB" :rules="[{ required: true, message: '商家所有购买广告总量不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="advertEditInfo.allTotalMaxForDirectionB"></el-input-number>
                </el-form-item>
                <el-form-item label="广告总数--买入" prop="advertisingTotalForB" :rules="[{ required: true, message: '广告总数--买入不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="advertEditInfo.advertisingTotalForB"></el-input-number>
                </el-form-item>
                <el-form-item label="广告总数--卖出" prop="advertisingTotalForS" :rules="[{ required: true, message: '广告总数--卖出不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="advertEditInfo.advertisingTotalForS"></el-input-number>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeDialog()">取消</el-button>
                    <el-button type="primary" @click="saveAdvertising()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import api from './api';
    import './store';
    import {mapActions, mapState} from 'vuex';
    import coinSelect from '../../../components/coinSelect';
    export default {
        name: "advertising",
        components:{coinSelect},
        data(){
            return {
                showEdit:false,
                opType: '',
                queryCondition:{
                    pageNo:1,
                    size:10,
                    coinType:'',
                    currencyCoin:''
                },
                advertEditInfo:{},
                merchantLevels:[{code:'V1',desc:'一级商户'},{code:'V2',desc:'二级商户'},{code:'V3',desc:'三级商户'},{code:'V4',desc:'四级商户'},{code:'V5',desc:'五级商户'}]
            }
        },
        computed : {...mapState('otcConfig',['advertTotal','advertInfo'])},
        methods:{
            ...mapActions('otcConfig',['findAdvertInfo']),
            closeDialog(){
                this.$refs['advertEditForm'].resetFields();
                this.advertEditInfo = {};
                this.showEdit = false;
            },
            queryAdvertising(){
                console.log(this.queryCondition)
                this.findAdvertInfo(this.queryCondition);
            },
            saveAdvertising(){
                this.$refs['advertEditForm'].validate(valid =>{
                    if (valid){
                        if (!this.advertEditInfo.coinType){this.$message.error('代币币种不能为空');return;}
                        if (!this.advertEditInfo.currencyCoin){this.$message.error('法币币种不能为空');return;}
                        if (this.opType === 'insert'){
                            api.advertInsert(this.advertEditInfo).then(()=>{
                                this.$message.success('新增成功');
                                this.queryCondition.pageNo = 1;
                                this.queryAdvertising();
                                this.closeDialog();
                            })
                        }
                        if (this.opType === 'update'){
                           api.advertUpdate(this.advertEditInfo).then(()=>{
                               this.$message.success('更新成功');
                               this.queryCondition.pageNo = 1;
                               this.queryAdvertising();
                               this.closeDialog();
                           })
                        }
                    }
                })
            },
            alterInfo(row){
              this.advertEditInfo = JSON.parse(JSON.stringify(row));
              this.opType = 'update';
              this.showEdit = true;
            },
            pageChange(val){
                this.queryCondition.pageNo = val;
                this.queryAdvertising();
            },
            sizeChange(val){
                this.queryCondition.size = val;
                this.queryAdvertising();
            }
        },
        created() {
            this.queryAdvertising();
        }
    }
</script>

<style scoped>

</style>